import { useState, useMemo, useCallback } from "react";

const DEFAULT_MERCHANT_FILTERS = {
  searchQuery: "",
  segment: "",
};

const DEFAULT_MERCHANT_PAGINATION = {
  pageIndex: 0,
  pageSize: 10,
};

export const useMerchantFilters = () => {
  const [filters, setFilters] = useState(DEFAULT_MERCHANT_FILTERS);
  const [pagination, setPagination] = useState(DEFAULT_MERCHANT_PAGINATION);

  const apiFilters = useMemo(
    () => ({
      merchantSegment: filters.segment,
      searchQuery: filters.searchQuery,
      page: pagination.pageIndex,
      size: pagination.pageSize,
    }),
    [filters, pagination.pageIndex, pagination.pageSize],
  );

  const resetPagination = useCallback(() => {
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  }, []);

  const setSearchQuery = useCallback(
    (query) => {
      setFilters((prev) => ({ ...prev, searchQuery: query }));
      resetPagination();
    },
    [resetPagination],
  );

  const setSegment = useCallback(
    (value) => {
      setFilters((prev) => ({ ...prev, segment: value || "" }));
      resetPagination();
    },
    [resetPagination],
  );

  return {
    filters,
    pagination,
    apiFilters,
    setPagination,
    resetPagination,
    searchQuery: filters.searchQuery,
    segment: filters.segment,
    setSearchQuery,
    setSegment,
  };
};

export default useMerchantFilters;
